<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="categorie-cours"
      v-model="sasDeclarationDeFormation.categorieDeCours"
      :live="liveSasDeclarationFormation(15002)"
    ></opq-catalogue>

    <search-numero-reconnaissance-formation
      v-if="estActiviteReconnue"
      @formation-selected="formationSelected($event)"
    ></search-numero-reconnaissance-formation>

    <opq-text-field
      :opq-if="estActiviteReconnue"
      code="numero-reconnaissance"
      v-model="sasDeclarationDeFormation.numeroDeReconnaissanceDeLActivite"
      :live="liveSasDeclarationFormation(15003)"
      :disabled="estActiviteReconnue"
      ref="numeroReconnaissance"
    ></opq-text-field>

    <opq-catalogue
      :opq-if="estCodeveloppement"
      code="codeveloppement-attestation-signee"
      v-model="sasDeclarationDeFormation.attestationDeParticipationCodeveloppementSignee"
      :live="liveSasDeclarationFormation(15004)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estUniversitaire"
      code="universitaire-credits"
      v-model="sasDeclarationDeFormation.leCoursDonneDroitADesCredits"
      :live="liveSasDeclarationFormation(15005)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estLecture"
      code="lecture-document-ecrit"
      v-model="sasDeclarationDeFormation.documentEcritDeNatureProfessionnelleOuScientifique"
      :live="liveSasDeclarationFormation(15007)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estPrestationFormation"
      code="prestation-formateur"
      v-model="sasDeclarationDeFormation.etiezVousLeFormateur"
      :live="liveSasDeclarationFormation(15008)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estPrestationSupervision || estSupervisionGroupe || estSupervisionIndiv"
      code="prestation-attestation-signee"
      v-model="sasDeclarationDeFormation.attestationDeConsultationSupervisionSignee"
      :live="liveSasDeclarationFormation(15009)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estPrestationSupervision"
      code="prestation-habilite"
      v-model="
        sasDeclarationDeFormation.etesVousHabiliteALExerciceDeLActiviteProfessionnellePourLaquelleVousEtesConsulteOuQueVousSupervisez
      "
      :live="liveSasDeclarationFormation(15010)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estRedaction"
      code="redaction-editeur-scientifique"
      v-model="sasDeclarationDeFormation.texteSoumisAUnEditeurScientifique"
      :live="liveSasDeclarationFormation(15011)"
    ></opq-catalogue>

    <opq-alert v-if="estCodeveloppement" code="info-codeveloppement"></opq-alert>

    <opq-text-field
      code="titre"
      v-model="sasDeclarationDeFormation.titre"
      :live="liveSasDeclarationFormation(15012)"
      :disabled="estActiviteReconnue"
      ref="titre"
      longueurMax="500"
    ></opq-text-field>

    <opq-catalogue
      code="domaine-activite"
      v-model="sasDeclarationDeFormation.domaineDeLActivite"
      :live="liveSasDeclarationFormation(15013)"
      :disabled="estActiviteReconnue"
      ref="domaineActivite"
    ></opq-catalogue>

    <opq-text-field
      :opq-if="estActiviteReconnue"
      code="formationreconnue-dispensateur"
      v-model="sasDeclarationDeFormation.dispensateur"
      :live="liveSasDeclarationFormation(15014)"
      :disabled="estActiviteReconnue"
      ref="formationReconnueDispensateur"
    ></opq-text-field>

    <opq-alert v-if="estMilieuTravail" code="info-formation-employeur"></opq-alert>

    <opq-text-field
      :opq-if="estCMQ || estHorsQC"
      code="organisation"
      v-model="sasDeclarationDeFormation.organisationQuiAOffertLaFormation"
      :live="liveSasDeclarationFormation(15015)"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estUniversitaire"
      code="universitaire-universite"
      v-model="sasDeclarationDeFormation.universiteDeFormation"
      :live="liveSasDeclarationFormation(15016)"
    ></opq-text-field>

    <opq-catalogue
      :opq-if="estUniversitaire"
      code="universitaire-type-participant"
      v-model="sasDeclarationDeFormation.typeDeParticipant"
      :live="liveSasDeclarationFormation(15017)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estHorsQC"
      code="HQ-type-activite"
      v-model="sasDeclarationDeFormation.typeDActivite"
      :live="liveSasDeclarationFormation(15018)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estHorsQC"
      code="HQ-pays-activite"
      v-model="sasDeclarationDeFormation.paysOuLActiviteAEuLieu"
      :live="liveSasDeclarationFormation(15019)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="
        estPsychotherapie &&
        (estCMQ || estCodeveloppement || estUniversitaire || estMilieuTravail || estPrestationFormation || estRedaction)
      "
      code="sujets-psychotherapie"
      v-model="sasDeclarationDeFormation.sujetsDeLActivitePsychotherapie"
      :live="liveSasDeclarationFormation(15020)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="
        estHorsPsychotherapie &&
        (estCMQ || estCodeveloppement || estUniversitaire || estMilieuTravail || estPrestationFormation || estRedaction)
      "
      code="sujets-hors-psychotherapie"
      v-model="sasDeclarationDeFormation.sujetsDeLActiviteHorsPsychotherapie"
      :live="liveSasDeclarationFormation(15021)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estPrestationFormation"
      code="prestation-type"
      v-model="sasDeclarationDeFormation.typeDePrestation"
      :live="liveSasDeclarationFormation(15022)"
    ></opq-catalogue>

    <opq-alert v-if="estActiviteReconnue || estUniversitaire" code="info-date-cours-activite-reconnue"></opq-alert>

    <opq-date-picker
      code="formation-reconnue-date-cours"
      v-model="sasDeclarationDeFormation.dateDuCours"
      :live="liveSasDeclarationFormation(15023)"
      :minYear="dateMin.getFullYear()"
      :maxYear="new Date().getFullYear() + 1"
      :condition="(v) => new Date(`${v}T00:00`) <= new Date() && new Date(`${v}T00:00`) >= dateMin"
      :conditionMessage="`La date doit se situer entre le ${$options.filters.datelong(dateMin)} et aujourd'hui.`"
    ></opq-date-picker>

    <opq-alert
      v-if="
        estCMQ ||
        estCodeveloppement ||
        estHorsQC ||
        estMilieuTravail ||
        estLecture ||
        estPrestationFormation ||
        estPrestationSupervision ||
        estRedaction ||
        estSupervisionGroupe ||
        estSupervisionIndiv
      "
      code="info-date-cours"
    >
    </opq-alert>

    <opq-text-field
      :opq-if="estRedaction"
      code="redaction-nombre-mots"
      v-model="sasDeclarationDeFormation.nombreDeMots"
      isNumber
      :live="liveSasDeclarationFormation(15026)"
    ></opq-text-field>

    <opq-time-picker
      code="duree"
      v-model="sasDeclarationDeFormation.duree"
      :live="liveSasDeclarationFormation(15027)"
      :maxHour="999"
      :minutesInterval="15"
      :condition="(v) => !!v && v.split(':').some((n) => parseInt(n) > 0)"
      conditionMessage="La durée doit être supérieure à 0h00."
    ></opq-time-picker>

    <opq-alert
      v-if="
        estCMQ ||
        estUniversitaire ||
        estHorsQC ||
        estMilieuTravail ||
        estPrestationFormation ||
        estCodeveloppement ||
        estActiviteReconnue ||
        estHorsQC ||
        estLecture ||
        estPrestationSupervision ||
        estSupervisionGroupe ||
        estSupervisionIndiv ||
        estRedaction
      "
      code="info-pieces-jointes"
    >
    </opq-alert>

    <opq-file-multiple
      :opq-if="estCMQ || estUniversitaire || estHorsQC || estMilieuTravail || estPrestationFormation"
      code="CMQ-description-activite"
      :files="sasDeclarationDeFormation.descriptionDeLActiviteOuPlanDeCours"
      :live="liveSasDeclarationFormation(15028)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estCMQ || estCodeveloppement || estActiviteReconnue || estHorsQC || estMilieuTravail"
      code="CMQ-attestation-participation"
      :files="sasDeclarationDeFormation.attestationDeParticipation"
      :live="liveSasDeclarationFormation(15029)"
      optional
    ></opq-file-multiple>

    <opq-alert v-if="estUniversitaire" code="info-attestation-etudiant"></opq-alert>

    <opq-file-multiple
      :opq-if="estUniversitaire"
      code="universitaire-attestation-participation"
      :files="sasDeclarationDeFormation.attestationDeParticipationUniversitaire"
      :live="liveSasDeclarationFormation(15030)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estHorsQC"
      code="HQ-recu-paiement"
      :files="sasDeclarationDeFormation.recuDePaiement"
      :live="liveSasDeclarationFormation(15031)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estLecture"
      code="lecture-descriptif"
      :files="sasDeclarationDeFormation.descriptifDuContenuOuReferences"
      :live="liveSasDeclarationFormation(15032)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estPrestationSupervision || estSupervisionGroupe || estSupervisionIndiv"
      code="prestation-attestation-consultation"
      :files="sasDeclarationDeFormation.attestationDeConsultationFormelleSupervision"
      :live="liveSasDeclarationFormation(15033)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estRedaction"
      code="redaction-lettre-editeur"
      :files="sasDeclarationDeFormation.lettreDeSoumissionALEditeurScientifique"
      :live="liveSasDeclarationFormation(15034)"
      optional
    ></opq-file-multiple>

    <opq-file-multiple
      :opq-if="estRedaction"
      code="redaction-texte-publication"
      :files="sasDeclarationDeFormation.textePresentePourPublication"
      :live="liveSasDeclarationFormation(15035)"
      optional
    ></opq-file-multiple>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import SearchNumeroReconnaissanceFormation from "@/components/Common/SearchNumeroReconnaissanceFormation"
export default {
  mixins: [CataloguesHelper, FormSimple],
  components: { SearchNumeroReconnaissanceFormation },
  props: {
    sas: { type: Object },
  },

  data() {
    return {
      dateMin: new Date(2017, 5, 22), // 22 juin 2017
    }
  },

  computed: {
    sasDeclarationDeFormation() {
      return this.sas.sasDeclarationDeFormation
    },
    estActiviteReconnue() {
      return this.estCategorie(1)
    },
    estCodeveloppement() {
      return this.estCategorie(4)
    },
    estUniversitaire() {
      return this.estCategorie(5)
    },
    estLecture() {
      return this.estCategorie(3)
    },
    estPrestationFormation() {
      return this.estCategorie(9)
    },
    estRedaction() {
      return this.estCategorie(11)
    },
    estMilieuTravail() {
      return this.estCategorie(6)
    },
    estPrestationSupervision() {
      return this.estCategorie(10)
    },
    estSupervisionGroupe() {
      return this.estCategorie(8)
    },
    estSupervisionIndiv() {
      return this.estCategorie(12)
    },
    estCMQ() {
      return this.estCategorie(2)
    },
    estHorsQC() {
      return this.estCategorie(7)
    },
    estPsychotherapie() {
      return this.estDomaineActivite(1)
    },
    estHorsPsychotherapie() {
      return this.estDomaineActivite(2)
    },
  },

  methods: {
    formationSelected(formation) {
      this.$refs.numeroReconnaissance.setValue(formation.numeroReconnaissance)
      this.$refs.titre.setValue(formation.titre)
      this.$refs.domaineActivite.setValue(formation.domaineDeLActivite)
      this.$refs.formationReconnueDispensateur.setValue(formation.dispensateur)
    },

    liveSasDeclarationFormation(cle) {
      return { endpoint: "/sas-declaration-formation/", cle: cle, fileId: this.sasDeclarationDeFormation.id }
    },
    estCategorie(codeCategorie) {
      return this.getCatalogueCodeById(4302, this.sas.sasDeclarationDeFormation.categorieDeCours) == codeCategorie
    },
    estDomaineActivite(codeDomaine) {
      return this.getCatalogueCodeById(9810, this.sas.sasDeclarationDeFormation.domaineDeLActivite) == codeDomaine
    },
  },
}
</script>

<style></style>
